import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';

import MainLayout from '../../Layout/main';

import Header from '../../Components/header-interna';
import ConteudoPrincipal from './Sections/conteudo-principal';
import Informacoes from './Sections/informacoes';
import Palestrantes from './Sections/palestrantes';
import Video from './Sections/video';
import Resumo from './Sections/resumo';
import Local from './Sections/local';
import InsituicoesParticipantes from './Sections/instituicoes-participantes';
import EventosRelacionados from './Sections/eventos-relacionados';

import { useLocation,  useParams } from 'react-router-dom';
import { fetchData } from '../../../Api';
import { EventInterface } from '../../Services/types';
import Galeria from '../../Components/galeria';

const IntegraEvento: React.FC<any> = ({initialData} : any) => {
    
    function proccessEvent()
    {        
        if (initialData == null) return;
        let event_format = initialData.event;
        event_format.data = new Date(event_format.data)                    
        return initialData.event;
    }

    function proccessEvents()
    {        
        if (initialData == null) return;
        const formattedEvents = initialData.events.map((event: EventInterface) => ({
            ...event,
            data: new Date(event.data),
        }));                    
                            
        return formattedEvents;
    }

    const { evento } = useParams<{ evento: string }>();
    const [event, setEvent] = useState<EventInterface | null>(proccessEvent());
    const [events, setEvents] = useState<any>(proccessEvents());
    const [eventoAberto, seteventoAberto] = useState<boolean>(false);
    const location = useLocation();
    const url = 'https://uniexpo.com.br' + location.pathname + location.search;      

    useEffect(() => {    
        if (!evento) return;        
        fetchData(`eventos/${evento}`).then(response => {
            if(response){
                if (response.event) {    
                    let event_format = response.event;
                    event_format.data = new Date(event_format.data)                    
                    setEvent(response.event);
                }
                if (response.events && response.events.length > 0) {                                       
                    const formattedEvents = response.events.map((event: EventInterface) => ({
                        ...event,
                        data: new Date(event.data),
                    }));                    
                                        
                    setEvents(formattedEvents);
                }
            }
        })      
    }, [evento]);  

    const descFormat = (html: string, maxLength = 150): string => {
        const plainText = html.replace(/<[^>]*>/g, '');
      
        return plainText.length > maxLength
          ? plainText.slice(0, maxLength).trim() + '...'
          : plainText;
    };

    const breadcrumb = [{
        name: 'Agenda de Eventos',
        slug: 'agenda-de-eventos',
    }];

    if(event){

        useEffect(() => {
            if(event.evento_ativo_de && event.evento_ativo_ate){
                const data_ini = new Date(event.evento_ativo_de);
                const data_fim = new Date(event.evento_ativo_ate);
                const eventoComecou = data_ini < new Date();
                const eventoTerminou = data_fim < new Date();
                if(eventoComecou === false)
                    seteventoAberto(true);
                else if(eventoTerminou === false)
                    seteventoAberto(false);
                else
                    seteventoAberto(true);
            }
            else if (event.data && event.horarioFim) {
                const data = new Date(event.data);
                const [horas, minutos, segundos] = event.horarioFim.split(':').map(Number);

                const dataComHorarioFim = new Date(data);
                dataComHorarioFim.setHours(horas, minutos, segundos);

                const eventoAberto = dataComHorarioFim < new Date();
                seteventoAberto(eventoAberto);
            }
            else{
                seteventoAberto(true);
            }
        }, [event.data, event.evento_ativo_de, event.evento_ativo_ate]);

        return (
            <>
                <Helmet>
                    <title>{event.titulo} - Uniexpo</title>
                    <meta name="description" content={event.yoast_desc || descFormat(event.content) || ''} />

                    <meta property="og:type" content="website" />
                    <meta property="og:url" content={url} />
                    <meta property="og:title" content={`${event.titulo || ''} - Uniexpo`} />
                    <meta property="og:description" content={event.yoast_desc || descFormat(event.content) || ''} />
                    <meta property="og:site_name" content="Uniexpo" />
                    <meta property="og:image" content={event.imagemDestaque || ''} />
                    <meta property="og:image:secure_url" content={event.imagemDestaque || ''} />
                    <meta property="og:image:type" content="image/jpeg" />

                    <meta name="twitter:card" content="summary_large_image" />
                    <meta name="twitter:title" content={`${event.titulo || ''} - Uniexpo`} />
                    <meta property="twitter:description" content={event.yoast_desc || descFormat(event.content) || ''} />
                    <meta name="twitter:image" content={event.imagemDestaque || ''} />
                </Helmet>
    
                <MainLayout>
                    <Header title={event.titulo} breadcrumb={breadcrumb} />

                    <ConteudoPrincipal buttons={event.botoes} inscricao={event.inscricao_link} content={event.content} date={event.data} horarioFim={event.horarioFim} imagem={event.imagemDestaque} apoio={event.apoiadores} programacao={event.programacao} type={event.tipo} eventoAberto={eventoAberto}/>

                    {event.galeria.length > 0 &&
                        <Galeria galeria={event.galeria} />
                    }

                    {!eventoAberto &&
                        <Informacoes inscricao={event.inscricao_link} date={event.data} inicio={event.horarioInicio} fim={event.horarioFim} local={event.local} />
                    }
                    {event.palestras.length > 0 && 
                        <Palestrantes palestras={event.palestras} />
                    }

                    {event.video && 
                        <Video video={event.video} />
                    }

                    {event.tituloInfo && event.textoInfo && event.imagemInfo &&
                        <Resumo titulo={event.tituloInfo} texto={event.textoInfo} imagem={event.imagemInfo} />
                    }

                    {event.local || event.google_maps ? (
                        <Local local={event.local} map={event.google_maps} />
                    ) : ''}

                    {event.participantes.length > 0 &&
                        <InsituicoesParticipantes participantes={event.participantes} />
                    }

                    {events && 
                        <EventosRelacionados events={events}/>
                    }
                </ MainLayout>
            </>
        );
    }
  
};

export default IntegraEvento;
